<template>
  <div
    :class="['modal fade', { show: showModal, 'd-block': showModal }]"
    tabindex="-1"
    :id="this.id || 'none'"
    @hidden="$emit('update:open', false)"
  >
    <slot name="body"></slot>
  </div>
</template>
<script>
export default {
  props: {
    open: Boolean,
    id: String,
  },
  data() {
    return {
      showModal: this.open,
      currentUrl: window.location.href,
    };
  },
  methods: {
    handleOutsideClick(event) {
      if (window.location.href !== this.currentUrl) {
        this.showModal = false;
      }
      // const modal = document.querySelector('.modal.show');
      // if (modal && !modal.contains(event.target)) {
      //   this.showModal = false;
      // }
    },
  },
  watch: {
    open(value) {
      this.showModal = value;
    },
    showModal(value) {
      this.$emit('update:open', value);
    },
  },
};
</script>
<style scoped></style>
